export const priceRegex = /^[1-9]\d*(\.\d+)?$|^0\.\d+?$/;
